import React from 'react';
import {
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Box,
	Chip,
	FormHelperText,
} from '@mui/material';

const CustomSelect = ({
	id,
	name,
	label,
	value = '',
	onChange,
	onBlur,
	items = [],
	required = false,
	disabled = false,
	error = false,
	helperText = '',
	fullWidth = true,
	showEmptyItem = false,
	sx = {},
	color = 'primary',
	testId = null,
	multiple = false,
	maxChipsToShow = 3,
	valueField = 'id',
	labelField = 'name',
	autoFocus = false,
	renderValue: customRenderValue,
}) => {
	const inputId =
		id || name || `select-${label?.replace(/\s+/g, '-').toLowerCase()}`;

	return (
		<FormControl
			fullWidth={fullWidth}
			required={required}
			disabled={disabled}
			error={error}
			color={color}
			variant="outlined"
			sx={{
				// Ensure it plays nice in flex containers
				minWidth: 120,
				...sx,
			}}
		>
			{label && <InputLabel id={`${inputId}-label`}>{label}</InputLabel>}
			<Select
				labelId={`${inputId}-label`}
				id={inputId}
				name={name}
				value={value}
				onChange={onChange}
				onBlur={onBlur}
				label={label}
				multiple={multiple}
				autoFocus={autoFocus}
				data-testid={testId}
				MenuProps={{
					PaperProps: {
						style: {
							maxHeight: 300,
						},
					},
				}}
				renderValue={
					customRenderValue ||
					((selected) => {
						if (multiple && Array.isArray(selected)) {
							if (selected.length === 0) return <em>None</em>;

							return (
								<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
									{selected.slice(0, maxChipsToShow).map((val, index) => {
										const item = items.find(
											(i) =>
												(typeof i === 'string' ? i : i[valueField]) === val,
										);
										const displayLabel = item
											? typeof item === 'string'
												? item
												: item[labelField]
											: val;

										return (
											<Chip
												key={index}
												label={displayLabel}
												size="small"
												sx={{ borderRadius: 1 }}
											/>
										);
									})}
									{selected.length > maxChipsToShow && (
										<Chip
											label={`+${selected.length - maxChipsToShow}`}
											size="small"
											sx={{ borderRadius: 1 }}
										/>
									)}
								</Box>
							);
						}

						if (
							selected === '' ||
							selected === null ||
							selected === undefined
						) {
							return showEmptyItem ? <em>None</em> : '';
						}

						const selectedItem = items.find(
							(item) =>
								(typeof item === 'string' ? item : item[valueField]) ===
								selected,
						);

						return selectedItem
							? typeof selectedItem === 'string'
								? selectedItem
								: selectedItem[labelField]
							: selected;
					})
				}
			>
				{showEmptyItem && (
					<MenuItem value="">
						<em>None</em>
					</MenuItem>
				)}
				{items.map((item, index) => {
					const itemValue = typeof item === 'string' ? item : item[valueField];
					const itemLabel = typeof item === 'string' ? item : item[labelField];
					return (
						<MenuItem key={index} value={itemValue}>
							{itemLabel}
						</MenuItem>
					);
				})}
			</Select>
			{helperText && <FormHelperText>{helperText}</FormHelperText>}
		</FormControl>
	);
};

export default CustomSelect;
